import type { MessageNode } from '../../types';
import { ConditionCard } from '../condition-card';
import { Bold, Times, Within } from '../condition-parts';
import { useServicesQuery } from '@/services/api';

function useCampaignName(
  campaignId: number | undefined,
  fallbackName: string | undefined,
  workspaceId: number,
): string | undefined {
  const shouldFetch = campaignId != null && campaignId > 0 && fallbackName == null && workspaceId > 0;

  const { data } = useServicesQuery(
    'getCampaignById',
    { params: { environment_id: workspaceId, campaign_id: String(campaignId ?? 0) } },
    { enabled: shouldFetch, staleTime: 5 * 60 * 1000 },
  );

  if (fallbackName != null) return fallbackName;
  return data?.campaign?.name;
}

interface MessageConditionProps {
  node: MessageNode;
  workspaceId: number;
}

export function MessageCondition({ node, workspaceId }: MessageConditionProps) {
  const campaignName = useCampaignName(node.campaignId, node.campaignName, workspaceId);

  return (
    <ConditionCard node={node}>
      <Bold>{node.displayName}</Bold>
      {campaignName != null ? (
        <>
          {' '}
          in <Bold>{campaignName}</Bold>
        </>
      ) : null}{' '}
      {node.action}
      {node.humanOnly ? ' by a human' : null}
      {node.href != null ? <> on the tracked link matching &quot;{node.href}&quot;</> : null}
      <Times times={node.times} />
      <Within within={node.within} />
    </ConditionCard>
  );
}
